import React, { Component } from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import cx from 'classnames';
import jwt from 'jsonwebtoken';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactHtmlParser from 'react-html-parser';
import s from './Dashboard.module.scss';
import EditorArea from './EditorArea';
import './main.css';
import { USER_ROLE } from '../../constants';


class GroupDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupInfo: {},
      treeData: [],
      allPricing: [],
      expandedGroups: {},
      loading: false,
      currUser: {},
      modalToggleNewDashboard: false,
      newDashboard: { title: '', body: '', highlight: false, code: '', codeHN: '', codeDN: '', location: 'HCM', type: 'item', parentId: null },
      modalToggleNewGroup: false,
      newGroup: { title: '', body: '', type: 'group', location: 'HCM', parentId: null },
      modalToggleUpdateGroup: false,
      groupContent: { title: '', body: '', location: 'HCM', parentId: null },
    };
    this.toggleGroup = this.toggleGroup.bind(this);
    this.toggleNewDashboard = this.toggleNewDashboard.bind(this);
    this.toggleNewGroup = this.toggleNewGroup.bind(this);
    this.toggleUpdateGroup = this.toggleUpdateGroup.bind(this);
    this.onAddnewDashboard = this.onAddnewDashboard.bind(this);
    this.onAddNewGroup = this.onAddNewGroup.bind(this);
    this.onUpdateGroup = this.onUpdateGroup.bind(this);
    this.onChangeNewDashboard = this.onChangeNewDashboard.bind(this);
    this.onChangeNewGroup = this.onChangeNewGroup.bind(this);
    this.onChangeNewGroup = this.onChangeNewGroup.bind(this);
    this.onChangeUpdateGroup = this.onChangeUpdateGroup.bind(this);
    this.deletePricing = this.deletePricing.bind(this);
  }

  deletePricing(id, title) {
    const { confirmAlert } = require('react-confirm-alert');
    require('react-confirm-alert/src/react-confirm-alert.css');

    confirmAlert({
      title: 'Xác nhận Xoá',
      message: `Bạn có chắc muốn xoá "${title}" không? Hành động này không thể hoàn tác.`,
      buttons: [
        {
          label: 'Có, Xoá ngay',
          onClick: async () => {
            try {
              await axios.get(`/delete-pricing/${id}`);
              toast.success('Xoá thành công');
              const { groupId } = this.props.match.params;
              this.fetchGroupData(groupId);
            } catch (err) {
              toast.error('Có lỗi xảy ra khi xoá');
            }
          },
        },
        { label: 'Huỷ', onClick: () => {} },
      ],
    });
  }

  async componentDidMount() {
    let token = localStorage.getItem('id_token');
    let currUser = jwt.decode(token);
    this.setState({ currUser: currUser });

    const { groupId } = this.props.match.params;
    await this.fetchGroupData(groupId);
  }

  async componentDidUpdate(prevProps) {
    const { groupId } = this.props.match.params;
    if (groupId !== prevProps.match.params.groupId) {
      await this.fetchGroupData(groupId);
    }
  }

  async fetchGroupData(groupId) {
    this.setState({ loading: true });
    try {
      // Get group info
      const resGroup = await axios.post(`/get-pricing/${groupId}`);
      this.setState({ groupInfo: resGroup.data || {} });

      // Get all pricing to build the tree and find children
      const resAll = await axios.get('/get-all-pricing?size=all');
      if (resAll && resAll.data && resAll.data.list) {
        this.setState({ allPricing: resAll.data.list });
        const tree = this.buildTree(resAll.data.list);
        const currentGroupNode = this.findNode(tree, groupId);
        this.setState({ treeData: currentGroupNode ? currentGroupNode.children : [] });
        
        // Update new item states with parentId and location
        const location = resGroup.data.location || 'HCM';
        this.setState({
          newDashboard: { ...this.state.newDashboard, parentId: groupId, location },
          newGroup: { ...this.state.newGroup, parentId: groupId, location }
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  }

  findNode(nodes, id) {
    for (const node of nodes) {
      if (node.id.toString() === id.toString()) return node;
      if (node.children) {
        const found = this.findNode(node.children, id);
        if (found) return found;
      }
    }
    return null;
  }

  buildTree(items) {
    const map = {};
    const tree = [];
    items.forEach(item => {
      map[item.id] = { ...item, children: [] };
    });
    items.forEach(item => {
      if (item.parentId && map[item.parentId]) {
        map[item.parentId].children.push(map[item.id]);
      } else {
        tree.push(map[item.id]);
      }
    });
    return tree;
  }

  toggleGroup(id) {
    this.setState(prevState => ({
      expandedGroups: {
        ...prevState.expandedGroups,
        [id]: !prevState.expandedGroups[id]
      }
    }));
  }

  toggleNewDashboard() {
    this.setState({
      modalToggleNewDashboard: !this.state.modalToggleNewDashboard,
    });
  }

  toggleNewGroup() {
    this.setState({
      modalToggleNewGroup: !this.state.modalToggleNewGroup,
    });
  }

  toggleUpdateGroup() {
    this.setState({
      modalToggleUpdateGroup: !this.state.modalToggleUpdateGroup,
      groupContent: this.state.groupInfo
    });
  }

  async onAddnewDashboard(e) {
    e.preventDefault();
    try {
      await axios.post('/create-pricing', this.state.newDashboard)
      const { groupId } = this.props.match.params;
      await this.fetchGroupData(groupId);
      this.toggleNewDashboard();
      this.setState({
        newDashboard: { ...this.state.newDashboard, title: '', body: '', highlight: false, code: '' },
      });
      toast.success('Thêm bảng giá thành công');
    } catch (err) {
      toast.error('Đã có lỗi xảy ra');
    }
  }

  async onAddNewGroup(e) {
    e.preventDefault();
    try {
      await axios.post('/create-pricing', this.state.newGroup)
      const { groupId } = this.props.match.params;
      await this.fetchGroupData(groupId);
      this.toggleNewGroup();
      this.setState({
        newGroup: { ...this.state.newGroup, title: '', body: '' },
      });
      toast.success('Thêm nhóm thành công');
    } catch (err) {
      toast.error('Đã có lỗi xảy ra');
    }
  }

  async onUpdateGroup(e) {
    e.preventDefault();
    try {
      const { groupId } = this.props.match.params;
      await axios.post(`/update-pricing/${groupId}`, this.state.groupContent)
      await this.fetchGroupData(groupId);
      this.toggleUpdateGroup();
      toast.success('Cập nhật nhóm thành công');
    } catch (err) {
      toast.error('Đã có lỗi xảy ra');
    }
  }

  onChangeNewDashboard(e, name) {
    if (name) {
      this.setState({
        newDashboard: { ...this.state.newDashboard, [name]: e },
      });
      return;
    }
    this.setState({
      newDashboard: { ...this.state.newDashboard, [e.target.name]: e.target.value },
    });
  }

  onChangeNewGroup(e, name) {
    if (name) {
      this.setState({
        newGroup: { ...this.state.newGroup, [name]: e },
      });
      return;
    }
    this.setState({
      newGroup: { ...this.state.newGroup, [e.target.name]: e.target.value },
    });
  }

  onChangeUpdateGroup(e, name) {
    if (name) {
      this.setState({
        groupContent: { ...this.state.groupContent, [name]: e },
      });
      return;
    }
    this.setState({
      groupContent: { ...this.state.groupContent, [e.target.name]: e.target.value },
    });
  }

  renderTreeOptions(nodes, level = 0) {
    let options = [];
    nodes.forEach(node => {
      if (node.type === 'group') {
        options.push(
          <option key={node.id} value={node.id}>
            {'\u00A0'.repeat(level * 4)}{level > 0 ? '↳ ' : ''}{node.title}
          </option>
        );
        if (node.children && node.children.length > 0) {
          options = options.concat(this.renderTreeOptions(node.children, level + 1));
        }
      }
    });
    return options;
  }

  renderTree(items, level = 0) {
    const { expandedGroups } = this.state;
    return items.map(item => {
      const isGroup = item.type === 'group';
      const isExpanded = expandedGroups[item.id];
      return (
        <React.Fragment key={item.id}>
          <div className={cx(s.pricingCard, isGroup ? s.pricingCardGroup : s.pricingCardItem)}>
            <div className={s.cardLeft} style={{ paddingLeft: `${level * 20}px` }}>
              {isGroup ? (
                <div 
                  className={s.toggleIcon} 
                  onClick={() => this.toggleGroup(item.id)}
                >
                  <i className={cx('fa', isExpanded ? 'fa-minus' : 'fa-plus')} />
                </div>
              ) : (
                <div className={s.itemIcon}>
                  <i className="fa fa-file-text-o" />
                </div>
              )}

              <div className="flex-grow-1">
                {isGroup ? (
                  <Link to={`/app/pricing/group/${item.id}`} className={s.cardTitle}>
                    <span className={s.title}>
                      {item.title || 'Nhóm chưa đặt tên'}
                    </span>
                  </Link>
                ) : (
                  <Link to={`/app/pricing/${item.id}`} className={s.cardTitle}>
                    <span className={cx(s.title, { 'text-danger fw-bold': item.highlight })}>
                      {item.title || 'Bảng giá chưa đặt tên'}
                    </span>
                  </Link>
                )}
              </div>
            </div>

            <div className={s.cardMeta}>
              <div className="mr-3">
                <i className="fa fa-clock-o mr-1" />
                {moment(item.updatedAt).fromNow()}
              </div>
              {(this.state.currUser.role === USER_ROLE.ADMIN || this.state.currUser.role === USER_ROLE.DOCUMENT) && (
                <button 
                  className={s.btnDeleteSmall}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.deletePricing(item.id, item.title);
                  }}
                  title="Xoá"
                >
                  <i className="fa fa-trash-o" />
                </button>
              )}
            </div>
          </div>
          {isGroup && isExpanded && (
            <div className={s.nestedWrapper}>
              {this.renderTree(item.children, level + 1)}
            </div>
          )}
        </React.Fragment>
      );
    });
  }

  render() {
    const { groupInfo, treeData, loading } = this.state;
    return (
      <div className={s.root}>
        {/* Breadcrumbs */}
        <div className={s.breadcrumbContainer}>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/app/pricing">Bảng giá</Link></li>
              <li className="breadcrumb-item active" aria-current="page">Chi tiết nhóm</li>
            </ol>
          </nav>
        </div>

        {/* Detail Header */}
        <div className={s.premiumHeader}>
          <div className={s.headerMain}>
            <div className={s.headerContent}>
              <div className={s.backLinkPremium} onClick={() => this.props.history.goBack()} style={{ cursor: 'pointer' }}>
                <i className="fa fa-chevron-left" /> Quay lại
              </div>
              <div className={s.titleRow}>
                <h1>{groupInfo.title || 'Đang tải...'}</h1>
                <div className={s.statusBadge}>
                  <i className="fa fa-map-marker" />
                  {groupInfo.location === 'HCM' ? 'Hồ Chí Minh' : groupInfo.location === 'HN' ? 'Hà Nội' : groupInfo.location === 'ĐN' ? 'Đà Nẵng' : 'Tham khảo'}
                </div>
              </div>
            </div>
            
            {this.state.currUser.email !== 'pricingtinphatexp@gmail.com' && (this.state.currUser.role === USER_ROLE.ADMIN || this.state.currUser.role === USER_ROLE.DOCUMENT) && (
              <div className={s.actionStack}>
                <button className={s.btnGhost} onClick={this.toggleUpdateGroup}>
                  <i className='fa fa-pencil' /> Chỉnh sửa
                </button>
                <div className={s.btnGroup}>
                  <button className={s.btnSecondary} onClick={this.toggleNewGroup}>
                    <i className='fa fa-folder-open-o' /> Thêm nhóm con
                  </button>
                  <button className={s.btnPrimary} onClick={this.toggleNewDashboard}>
                    <i className='fa fa-plus' /> Thêm bảng giá
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Group Description */}
        {groupInfo.body && (
          <div className={cx(s.contentCard, s.groupDescription)}>
            <div className={s.contentTitle} style={{ fontSize: '18px', marginBottom: '16px' }}>Thông tin bổ sung</div>
            <div className="description-content">
              {ReactHtmlParser(groupInfo.body)}
            </div>
          </div>
        )}

        {/* Content List */}
        <div className={s.listContainer}>
          {loading ? (
            <div className="text-center py-5">
              <i className="fa fa-circle-o-notch fa-spin fa-2x text-primary" />
              <p className="mt-2 text-muted">Đang tải nội dung nhóm...</p>
            </div>
          ) : treeData && treeData.length > 0 ? (
            this.renderTree(treeData)
          ) : (
            <div className={s.pricingCard} style={{ justifyContent: 'center', padding: '40px' }}>
              <div className="text-center text-muted">
                <i className="fa fa-folder-open-o fa-3x mb-3 opacity-20" />
                <p>Nhóm này hiện chưa có bảng giá hoặc nhóm con</p>
              </div>
            </div>
          )}
        </div>

        <ToastContainer position='top-right' autoClose={3000} hideProgressBar />

        {/* Modals for New Pricing and New Group */}
        <Modal
          isOpen={this.state.modalToggleNewDashboard}
          toggle={this.toggleNewDashboard}
          size="lg"
        >
          <ModalHeader>Tạo bảng giá mới</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for='title'>Tiêu đề</Label>
              <Input
                value={this.state.newDashboard.title}
                name='title'
                id='title'
                placeholder='Nhập tiêu đề bảng giá...'
                onChange={(e) => this.onChangeNewDashboard(e)}
              />
            </FormGroup>
            <FormGroup>
              <Label for='parentId'>Thuộc nhóm</Label>
              <Input
                type="select"
                name="parentId"
                id="parentId"
                value={this.state.newDashboard.parentId || ''}
                onChange={(e) => this.onChangeNewDashboard(e)}
              >
                <option value="">-- Không thuộc nhóm nào (Gốc) --</option>
                {this.renderTreeOptions(this.buildTree(this.state.allPricing))}
              </Input>
            </FormGroup>
            <FormGroup style={{ minHeight: '400px' }}>
              <Label for='content'>Nội dung chi tiết</Label>
              <EditorArea
                value={this.state.newDashboard.body}
                onChange={(e) => this.onChangeNewDashboard(e, 'body')}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color='success' className="px-4" onClick={(e) => this.onAddnewDashboard(e)}>Lưu lại</Button>
            <Button color='secondary' onClick={this.toggleNewDashboard}>Đóng</Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.modalToggleNewGroup}
          toggle={this.toggleNewGroup}
          size="lg"
        >
          <ModalHeader>Tạo nhóm mới</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for='titleGroup'>Tên nhóm</Label>
              <Input
                value={this.state.newGroup.title}
                name='title'
                id='titleGroup'
                placeholder='Ví dụ: Cước tàu biển, Phụ phí...'
                onChange={(e) => this.onChangeNewGroup(e)}
              />
            </FormGroup>
            <FormGroup>
              <Label for='parentIdGroup'>Thuộc nhóm cha</Label>
              <Input
                type="select"
                name="parentId"
                id="parentIdGroup"
                value={this.state.newGroup.parentId || ''}
                onChange={(e) => this.onChangeNewGroup(e)}
              >
                <option value="">-- Cấp gốc (Root) --</option>
                {this.renderTreeOptions(this.buildTree(this.state.allPricing))}
              </Input>
            </FormGroup>
            <FormGroup style={{ minHeight: '300px' }}>
              <Label for='contentGroup'>Mô tả chi tiết nhóm</Label>
              <EditorArea
                value={this.state.newGroup.body}
                onChange={(e) => this.onChangeNewGroup(e, 'body')}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color='primary' className="px-4" onClick={(e) => this.onAddNewGroup(e)}>Tạo nhóm</Button>
            <Button color='secondary' onClick={this.toggleNewGroup}>Huỷ</Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.modalToggleUpdateGroup}
          toggle={this.toggleUpdateGroup}
          size="lg"
        >
          <ModalHeader>Chỉnh sửa nhóm</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for='titleUpdateGroup'>Tên nhóm</Label>
              <Input
                value={this.state.groupContent.title}
                name='title'
                id='titleUpdateGroup'
                placeholder='Nhập tên nhóm...'
                onChange={(e) => this.onChangeUpdateGroup(e)}
              />
            </FormGroup>
            <FormGroup>
              <Label for='parentIdUpdateGroup'>Thuộc nhóm cha</Label>
              <Input
                type="select"
                name="parentId"
                id="parentIdUpdateGroup"
                value={this.state.groupContent.parentId || ''}
                onChange={(e) => this.onChangeUpdateGroup(e)}
              >
                <option value="">-- Cấp gốc (Root) --</option>
                {this.renderTreeOptions(this.buildTree(this.state.allPricing))}
              </Input>
            </FormGroup>
            <FormGroup style={{ minHeight: '300px' }}>
              <Label for='contentUpdateGroup'>Mô tả chi tiết nhóm</Label>
              <EditorArea
                value={this.state.groupContent.body}
                onChange={(e) => this.onChangeUpdateGroup(e, 'body')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="locationUpdateGroup">Khu vực</Label>
              <Input id="locationUpdateGroup" name="location" value={this.state.groupContent.location} type="select" onChange={(e) => this.onChangeUpdateGroup(e)}>
                <option value="HCM">Hồ Chí Minh</option>
                <option value="HN">Hà Nội</option>
                <option value="ĐN">Đà Nẵng</option>
                <option value="Custom">GIÁ BÁN THAM KHẢO</option>
              </Input>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color='success' className="px-4" onClick={(e) => this.onUpdateGroup(e)}>Lưu thay đổi</Button>
            <Button color='secondary' onClick={this.toggleUpdateGroup}>Huỷ</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default GroupDetail;
